import { render } from "./PaywallSettings.vue?vue&type=template&id=0ddf3e10"
import script from "./PaywallSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./PaywallSettings.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Paywall/PaywallSettings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0ddf3e10"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0ddf3e10', __exports__)) {
    api.reload('0ddf3e10', __exports__)
  }
  
  module.hot.accept("./PaywallSettings.vue?vue&type=template&id=0ddf3e10", () => {
    api.rerender('0ddf3e10', render)
  })

}


export default __exports__